export default __webpack_public_path__ + "static/media/login_bg_bottom.ae00fef8.png";